import { useService } from "@/base/hooks/useService";
import { StorageService } from "@services/StorageService";
import { localstorageKeys } from "@const/store";

const useCookies = () => {
  const storageService = useService(StorageService);

  const setNecessaryCookies = () => {
    storageService.set(localstorageKeys.necessaryCookies, new Date());
  };

  const setMarketingCookies = (value) => {
    storageService.set(localstorageKeys.marketingCookies, value);
    if (!value) {
      storageService.remove(localstorageKeys.marketingCookies);
    }
  };

  const setFunctionalCookies = (value) => {
    storageService.set(localstorageKeys.functionalCookies, value);
    if (!value) {
      storageService.remove(localstorageKeys.functionalCookies);
    }
  };

  return {
    setNecessaryCookies,
    setMarketingCookies,
    setFunctionalCookies,
  };
};

export default useCookies;
